const todoData = [
  {
    id: 1,
    status: "completed",
    description: "Completed task",
    created: "created 17 seconds ago",
  },
  {
    id: 2,
    status: "editing",
    description: "Editing task",
    created: "created 5 minutes ago",
  },
  {
    id: 3,
    status: false,
    description: "Active task",
    created: "created 5 minutes ago",
  },
];

export default todoData;
